import styled from 'styled-components';
import { prefix } from '../../../tools/settings';
var Step = styled.div.withConfig({
  displayName: "Stepstyles__Step",
  componentId: "sc-1x8rq7l-0"
})(["display:none;&.", "-wizard__step--isActive{display:block;}&.", "-wizard__step--isDisabled{opacity:0.5;}"], prefix, prefix);
var StepInner = styled.div.withConfig({
  displayName: "Stepstyles__StepInner",
  componentId: "sc-1x8rq7l-1"
})(["width:100%;max-width:", ";margin:var(--dentsu-spacing-32) auto var(--dentsu-spacing-48);"], function (props) {
  return props.isFullWidth ? '100%' : '872px';
});
export var Styled = {
  Step: Step,
  StepInner: StepInner
};